// https://vuex.vuejs.org/en/state.html
import variables from '@/utils/variables'

export default {
  baseUrl: variables.baseUrl,
  cancelTokens: [],
  cashRegister: {},
  customers: [],
  defaultPrinter: 'Citizen',
  defaultLocale: variables.defaultLocale,
  identifier: null,
  isFullScreen: false,
  isMini: false,
  isOnline: true,
  isQzTrayInstalled: false,
  printer: null,
  products: [],
  secondaryLocale: variables.secondaryLocale,
  stocks: [],
  showFullCatalog: false
}
